import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4>{`Awesome List`}</h4>
    <br />
    <blockquote>
      <p parentName="blockquote"><strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/12101111/rcc"
          }}>{`rcc`}</a></strong>{`: C compiler written in Rust.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/12101111/yolo-rs"
          }}>{`yolo-rs`}</a></strong>{`: About
Yolov3 & Yolov4 with TVM and Rust.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/raptazure/unity.kv"
          }}>{`unity.kv`}</a></strong>{`: A multi-threaded, persistent key/value store.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/raptazure/medis.tk"
          }}>{`medis.tk`}</a></strong>{`: Minimal Redis client and server implementation using Tokio.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/12101111/fbterm"
          }}>{`fbterm`}</a></strong>{`: A terminal emulator for any framebuffer. Also contains an abstraction of the framebuffer, which can draw images by pixel.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/raptazure/mandelbrot"
          }}>{`mandelbrot`}</a></strong>{` - A parallel mandelbrot set generator.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/12101111/oxidenes"
          }}>{`oxidenes`}</a></strong>{`: This is just another NES emulator.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/miRoox/wll-rs"
          }}>{`wll`}</a></strong>{`: Wolfram LibraryLink interface for Rust.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/12101111/nettest"
          }}>{`nettest`}</a></strong>{`: All-in-one network test tool.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/12101111/os"
          }}>{`12101111-os`}</a></strong>{`: Operating system written in Rust. Only support UEFI x86`}{`*`}{`64.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/Lincyaw/Rust_os_summer"
          }}>{`os-summer`}</a></strong>{`: A joint project between Tsinghua University and Pengcheng Lab.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/Jaic1/xv6-riscv-rust"
          }}>{`xv6-riscv-rust`}</a></strong>{`: A project intending to port xv6-riscv using Rust.`}<br parentName="p"></br>{`
`}<strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/raptazure/mengine.rs"
          }}>{`mengine.rs`}</a></strong>{`: A minimal browser engine written in Rust.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      